import React from "react";
import {Box} from "@mui/material";
import {keyframes} from "@mui/system";

/**
 * Fullscreen černá obrazovka s neviditelnou CSS animací.
 * TV detekuje změny pixelů a zůstane zapnutá (nepřepne se do standby).
 * Animace je pro lidské oko neviditelná (1px bod, velmi nízká opacity).
 */

const drift = keyframes`
    0%   { transform: translate(0, 0); }
    25%  { transform: translate(100vw, 30vh); }
    50%  { transform: translate(50vw, 90vh); }
    75%  { transform: translate(80vw, 10vh); }
    100% { transform: translate(0, 0); }
`;

const BlackScreen: React.FC = () => (
    <Box
        sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            bgcolor: "#000",
            zIndex: 9999,
            overflow: "hidden",
            cursor: "none",
        }}
    >
        {/* Neviditelný pixel s pomalou animací – udržuje TV signál aktivní */}
        <Box
            sx={{
                position: "absolute",
                width: "2px",
                height: "2px",
                bgcolor: "rgba(1, 1, 1, 0.02)",
                borderRadius: "50%",
                animation: `${drift} 120s linear infinite`,
            }}
        />
    </Box>
);

export default BlackScreen;
